import { Box, Grid,Typography } from '@mui/material'
import React from 'react';
import CropSquareIcon from '@mui/icons-material/CropSquare';
import CloseIcon from '@mui/icons-material/Close';
import ChangeHistoryIcon from '@mui/icons-material/ChangeHistory';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { HOW, ITWORKS } from '../../Constant/constant';
const HowItWork = () => {
  return (
      <Grid container sx={{textAlign:'center',paddingLeft:'5%',paddingRight:'5%'}}>
        <Grid item xl={12} sm={12} xs={12} md={12} lg={12} sx={{width:'100%',fontSize:'18px',marginBottom:'10%'}}>
          <Typography variant='h5' sx={{fontFamily:'Pirulen',fontSize:'19pt'}}><Typography variant='body' sx={{color:'#295fd6',fontFamily:'Pirulen'}}>{HOW}</Typography>{ITWORKS}</Typography>
        </Grid>
        <Grid item xl={3} sm={12} xs={12} md={3} lg={3} className="container"  sx={{marginTop:'5%'}}>
        <Box className="textletter">D</Box>
            <Box className="overlay">
            <Box className='image-bg-url'>
              <Box sx={{opacity:'0.2'}}>
                <CropSquareIcon sx={{fontSize:'15rem'}}/>
              </Box>
              </Box>
              <Typography className="texts">Stake DefyTokens</Typography>
            </Box>
        </Grid>
        <Grid item xl={3} sm={12} xs={12} md={3} lg={3} className="container" sx={{marginTop:'5%'}}>
        <Box className="filltextletter" >E</Box>
            <Box className="overlay">
              <Box className='image-bg-url'>
              <Box sx={{opacity:'0.2'}}>
                <CloseIcon sx={{fontSize:'15rem'}} />
              </Box>
              </Box>
              <Typography className="texts">Earn Rewards & Play Games</Typography>
            </Box>
        </Grid>
        <Grid item xl={3} sm={12} xs={12} md={3} lg={3} className="container" sx={{marginTop:'5%'}}>
        <Box className="textletter">F</Box>
            <Box className="overlay">
            <Box className='image-bg-url'>
              <Box sx={{opacity:'0.2'}}>
                <ChangeHistoryIcon sx={{fontSize:'15rem'}}/>
              </Box>
              </Box>
              <Typography className="texts">Earn IDO Allocation</Typography>
            </Box>
        </Grid>
        <Grid item xl={3} sm={12} xs={12} md={3} lg={3} className="container" sx={{marginTop:'5%'}}>
        <Box className="filltextletter">Y</Box>
            <Box className="overlay">
            <Box className='image-bg-url'>
              <Box sx={{opacity:'0.2'}}>
                <RadioButtonUncheckedIcon sx={{fontSize:'15rem'}}/>
              </Box>
              </Box>
              <Typography className="texts">Redeem Rewards</Typography>
            </Box>
        </Grid>
      </Grid>
  );
};

export default HowItWork;